import { useMutation } from '@tanstack/react-query';
import { postActivityFeedComment } from '../Services/ProcessedTimesheetService';

const usePostActivityFeedComment = (options = {}) => useMutation(postActivityFeedComment, options);

export default usePostActivityFeedComment;
